<ng-container *ngIf="form">
  <div class="form-list-item">
    <div class="name">
      <ng-container *ngIf="form.archivedAt">
        <i class="pi pi-inbox" tooltipPosition="right" pTooltip="Archived"></i>
      </ng-container>
      {{ form.name }}
    </div>
    <div class="take-payment">
      {{ form.takePayment ? ('forms.components.list_item.yes' | translate) : ('forms.components.list_item.no' | translate) }}
    </div>
    <div class="status">
      <div class="capsule">
        <ng-container *ngIf="form.isDraft">
          <capsule label="{{'forms.components.list_item.draft' | translate}}" backgroundColor="var(--orange-400)" [small]="true"></capsule>
        </ng-container>
        <ng-container *ngIf="!form.isDraft">
          <capsule label="{{'forms.components.list_item.published' | translate}}" backgroundColor="var(--success-color)" [small]="true"></capsule>
        </ng-container>
      </div>
    </div>
    <div class="actions">
      <div class="actions-opener" (clickOutside)="actionsOpen = false" (click)="toggleActions()"><img
          src="assets/images/icons/dots.svg" alt=""></div>
      <ng-container *ngIf="actionsOpen">
        <div class="actions-dropdown">
          <div class="action" (click)="editForm()">
            {{'forms.components.list_item.edit' | translate}}
          </div>
          <div class="action" (click)="duplicateForm()">
            {{'forms.components.list_item.duplicate' | translate}}
          </div>
          <ng-container *ngIf="form.archivedAt">
            <div class="action" (click)="archive(false)">
              {{'forms.components.list_item.restore' | translate}}
            </div>
          </ng-container>
          <ng-container *ngIf="!form.archivedAt">
            <div class="action" (click)="archive()">
              {{'forms.components.list_item.archive' | translate}}
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>